<template>
  <el-dialog :close-on-click-modal="false"
             :close-on-press-escape="false"
             :show-close="false"
             width="800px"
             title="缓存管理"
             :visible.sync="visible">
    <el-table
      :data="table.slice((pagination.current_page - 1) * pagination.per_page, pagination.current_page * pagination.per_page)"
      stripe
      highlight-current-row
      border
      v-loading="loading"
      element-loading-text="正在读取缓存中……"
      style="width: 100%">
      <el-table-column prop="key"
                       label="KEY"></el-table-column>
      <el-table-column prop="created_at"
                       label="创建日期"
                       width="185"></el-table-column>
      <el-table-column prop="updated_at"
                       label="更新日期"
                       width="185"></el-table-column>
      <el-table-column fixed="right"
                       label="操作"
                       width="80">
        <template slot-scope="scope">
          <el-button type="danger"
                     size="mini"
                     @click="onRead(scope.row.key)">读取
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 15px;">
      <el-pagination background
                     layout="total, prev, pager, next, jumper"
                     @current-change="handleCurrentPageChange"
                     :current-page="pagination.current_page"
                     :page-size="pagination.per_page"
                     :total="pagination.total">
      </el-pagination>
    </div>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="visible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import CacheDB from '../cache-db'

export default {
  mixins: [],
  components: {},
  data () {
    return {
      key: null,
      table: [],
      pagination: {
        current_page: 1,
        per_page: 4,
        total: 0,
      },
      loading: false,
      visible: false,
      callback: Function.prototype,
    }
  },
  computed: {},
  watch: {
    visible (val) {
      if (val === false) {
        Object.assign(this.$data, this.$options.data())
      } else {
        CacheDB.getOrderItem(this.key).then((items) => {
          this.table = items.reverse()
          this.pagination.total = this.table.length
        })
      }
    },
  },
  created () {
  },
  mounted () {},
  destroyed () {},
  methods: {
    onRead (key) {
      this.loading = true
      CacheDB.getVersionItem(key).then((val) => {
        this.loading = false
        this.visible = false
        this.callback(val)
      })
    },
    handleCurrentPageChange (val) {
      this.pagination.current_page = val
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"
       scoped>
</style>



// WEBPACK FOOTER //
// src/views/question-review/components/CacheManage/src/main.vue